import { fromJS } from 'immutable';

export const initialState = fromJS({
    isLoading: false,
    facilities: []
});